import { render } from "./MoveItems.vue?vue&type=template&id=480631ce"
import script from "./MoveItems.vue?vue&type=script&lang=js"
export * from "./MoveItems.vue?vue&type=script&lang=js"
script.render = render

export default script